import { render, staticRenderFns } from "./_products.vue?vue&type=template&id=165afa4b&scoped=true"
import script from "./_products.vue?vue&type=script&lang=js"
export * from "./_products.vue?vue&type=script&lang=js"
import style0 from "./_products.vue?vue&type=style&index=0&id=165afa4b&prod&scoped=true&lang=css"
import style1 from "./_products.vue?vue&type=style&index=1&id=165afa4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165afa4b",
  null
  
)

export default component.exports